export default __webpack_public_path__ + "static/media/presentGirl.bab4a1b1.jpg";